export const dialogNames = {
  profile: 'profile',
  changeEmail: 'change_email',
  resetPassword: 'reset_password',
  completion: 'completion',
} as const;
